import React from "react";
import "./layout.css";

import brandLogo from "../assets/logo.png";
import brochurePdf from "../assets/Shubha_Graphics.pdf";
import { FiPhoneCall, FiDownload } from "react-icons/fi";

export default function Layout() {
  return (
    <div className="layout-root">
      <header className="site-header">
        <div className="site-header__inner">
          {/* Left: logo image (logo + name in one image) */}
          <div className="site-header__left">
            <img
              src={brandLogo}
              alt="Shubha Graphics"
              className="site-header__logo"
            />
          </div>

          {/* Right: phone + download brochure */}
          <div className="site-header__right">
            {/* <a
              className="header-pill"
              href="tel:+919483838409"
              aria-label="Call Shubha Graphics: 9483838409, 8861079975"
            >
              <span className="header-pill__iconWrap" aria-hidden="true">
                <FiPhoneCall className="header-pill__icon" />
              </span>
              <span className="header-pill__text">9483838409, 8861079975</span>
            </a> */}

            <a
              className="header-pill"
              href={brochurePdf}
              download
              aria-label="Download Brochure"
            >
              <span className="header-pill__iconWrap" aria-hidden="true">
                <FiDownload className="header-pill__icon" />
              </span>
              <span className="header-pill__text"> Brochure</span>
            </a>
          </div>
        </div>
      </header>
    </div>
  );
}